import * as React from "react";
export function useCallbackRef() {
    var _a = React.useState(null), ref = _a[0], setRef = _a[1];
    var fn = React.useCallback(function (node) {
        if (node !== null) {
            setRef(node);
        }
    }, []);
    return [ref, fn];
}
